module.exports = __webpack_public_path__ + "static/targetcheck2-daf93cd548f39afad3019f22fd3f2967.png";